import { render, staticRenderFns } from "./ModeratorQuestionModal.vue?vue&type=template&id=73c1c545"
import script from "./ModeratorQuestionModal.vue?vue&type=script&lang=js"
export * from "./ModeratorQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports